/**
 * TeachOnEmpty — replace "0" with a helpful next step
 *
 * Used in places where a zero metric would be confusing/intimidating for a
 * first-time user. Dashed border, friendly icon, link to the action that
 * unlocks data.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

export default function TeachOnEmpty({
  icon: Icon = Sparkles,
  title,
  body,
  ctaLabel = 'Start →',
  ctaHref,
  estimatedTime,
  testid,
}) {
  return (
    <div
      className="rounded-xl border-2 border-dashed border-slate-800 bg-slate-900/50 p-6 sm:p-8 flex flex-col items-center text-center"
      data-testid={testid || 'teach-on-empty'}
    >
      <div className="h-10 w-10 rounded-full bg-emerald-500/10 ring-1 ring-emerald-500/20 flex items-center justify-center mb-3">
        <Icon className="w-5 h-5 text-emerald-400" />
      </div>
      <div className="text-sm font-semibold text-slate-100 max-w-md">{title}</div>
      {body && (
        <div className="text-xs text-slate-400 mt-2 max-w-md leading-relaxed">{body}</div>
      )}
      {estimatedTime && (
        <div className="text-[10px] text-slate-500 font-mono mt-2">⏱ {estimatedTime}</div>
      )}
      {ctaHref && (
        <Link
          to={ctaHref}
          className="mt-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-emerald-500/15 ring-1 ring-emerald-500/30 text-emerald-300 hover:bg-emerald-500/25 text-xs font-medium transition-colors"
        >
          {ctaLabel} <ArrowRight className="w-3 h-3" />
        </Link>
      )}
    </div>
  );
}
